module.exports = __webpack_public_path__ + "resource/img/clock.6ede7a03.svg";